module.exports = __webpack_public_path__ + "img/secret.e1d25d89.svg";